import React from 'react'
import { useState } from 'react';
import { Link } from 'react-router-dom'
import { FaArrowRight } from "react-icons/fa";
import HighlightText from '../components/core/HomePage/HighlightText';
import CTAButton from '../components/core/HomePage/Button';
import Banner from "../assets/Images/banner.mp4"
import CodeBlocks from '../components/core/HomePage/CodeBlocks';
import TimelineSection from '../components/core/HomePage/TimelineSection';
import LearningLanguageSection from '../components/core/HomePage/LearningLanguageSection';
import InstructorSection from '../components/core/HomePage/InstructorSection';
import Footer from '../components/common/Footer';
import ExploreMore from '../components/core/HomePage/ExploreMore';
import ReviewSlider from '../components/common/ReviewSlider';



const Home = () => {

  return (
    <div className="mt-[70px]">
        {/* section 1 */}
        <div className='relative mx-auto flex flex-col w-11/12 max-w-maxContent items-center 
      text-white justify-between'>
            <Link to={"/signup"}>
            <div className=' group mt-16 p-1 mx-auto rounded-full bg-richblack-800 font-bold text-richblack-200
            transition-all duration-200 hover:scale-95 w-fit'>
                <div className='flex flex-row items-center gap-2 rounded-full px-10 py-[5px]
                transition-all duration-200 group-hover:bg-richblack-900'>
                    <p>Become an Instructor</p>
                    <FaArrowRight />
                    </div>
                </div>
            </Link>

            <div className='text-center text-4xl font-semibold mt-7'>
                Empower Your Future with
                <HighlightText text={"Coding Skills"}></HighlightText>
            </div>

            <div className=' mt-4 w-[90%] text-center text-lg font-bold text-richblack-300'>
            With our online coding courses, you can learn at your own pace, 
            from anywhere in the world, and get access to a wealth of resources, 
            including hands-on projects, quizzes, and personalized feedback from instructors. 
            </div>

            <div className='flex flex-row gap-7 mt-8'>
                <CTAButton active={true} linkto={"/signup"}> 
                    Learn More
                </CTAButton>

                <CTAButton active={false} linkto={"/login"}>
                    Book a Demo
                </CTAButton>
            </div>

            <div className='mx-3 my-12 shadow-blue-200'>
                <video
                muted
                loop
                autoPlay
                >
                    <source src={Banner} type="video/mp4" />
                </video>
            </div>

            {/* code section 1 */}
            
            <div>
                <CodeBlocks 
                 position={"lg:flex-row "}
                 heading= {
                    <div className='text-4xl font-semibold '>
                        Unlock Your
                        <HighlightText text={"coding potential  "}></HighlightText>
                        with our online courses 
                    </div>
                 }
                 subheading={
                    "Our courses are designed and taught by industry experts who have years of experience in coding and are passionate about sharing their knowledge with you."
                 } 
                 ctabtn1 ={
                     {
                        btnText: "Try it yourself",
                        linkto: "/signup",
                        active: true
                     }
                 }
                 ctabtn2 ={
                    {
                        btnText: "learn more",
                        linkto: "/login",
                        active: false
                    }
                 }
                 codeblock={
                    `<!DOCTYPE html>\n<html>\nhead><title>Example</title><linkrel="stylesheet"href="styles.css">
                    /head>\nbody>\nh1><ahref="/">Header</a>\n/h1>\nnav><ahref="one/">One</a><ahref="two/">Two</a><ahref="three/">Three</a>
                    /nav>`
                 }
                 codeColor={
                    "text-yellow-25"
                 }>

                </CodeBlocks>
            </div>

            {/* code section 2 */}
            
            <div>
                <CodeBlocks 
                 position={"lg:flex-row-reverse  "}
                 heading= {
                    <div className='text-4xl font-semibold '>
                        Start
                        <HighlightText text={"coding in seconds"}></HighlightText>
                        
                    </div>
                 }
                 subheading={
                    "Go ahead, give it a try. Our hands-on learning environment means you'll be writing real code from your very first lesson."
                 } 
                 ctabtn1 ={
                     {
                        btnText: "Continue Lesson",
                        linkto: "/signup",
                        active: true
                     }
                 }
                 ctabtn2 ={
                    {
                        btnText: "learn more",
                        linkto: "/login",
                        active: false
                    }
                 }
                 codeblock={
                    `<!DOCTYPE html>\n<html>\nhead><title>Example</title><linkrel="stylesheet"href="styles.css">
                    /head>\nbody>\nh1><ahref="/">Header</a>\n/h1>\nnav><ahref="one/">One</a><ahref="two/">Two</a><ahref="three/">Three</a>
                    /nav>`
                 }
                 codeColor={
                    "text-yellow-25"
                 }>

                </CodeBlocks>
            </div>


            <ExploreMore></ExploreMore>


        </div>

        {/* section 2 */}
        <div className='bg-pure-greys-5 text-richblack-700 '>
            <div className='homepage_bg h-[310px] '>
                <div className='w-11/12 max-w-maxContent flex flex-col items-center justify-between gap-5 mx-auto'>
                    <div className='h-[150px]'></div>
                    <div className='flex flex-row gap-7 text-white lg:mt-14'>
                        <CTAButton active={true} linkto={"/signup"}>
                            <div className='flex items-center gap-3'>
                            Explore Full Catalog
                            <FaArrowRight />
                            </div>
                            
                        </CTAButton>

                        <CTAButton active={false} linkto={"/signup"}>
                            <div className='flex items-center gap-3'>
                            Learn More
                            <FaArrowRight />
                            </div>
                            </CTAButton>
                    </div>
                </div>

            </div>


            <div className='mx-auto w-11/12 max-w-maxContent flex gap-7 flex-col 
            items-center justify-between'>
                <div className='flex flex-row   justify-center gap-5 mt-[95px] mb-10'>
                    <div className='text-4xl font-semibold w-[45%]'>
                    Get the skills you need for a 
                    <HighlightText text = {"job that is in demand."}></HighlightText>
                    </div>

                    <div className='flex gap-10 flex-col w-[40%] items-start'>
                        <div className='text-[16px]'>
                        The modern StudyNotion is the dictates its own terms. Today, to be a competitive specialist requires more than professional skills.
                        </div>
                        
                            <CTAButton active={true} linkto={"/signup"}>
                               <div>
                               Learn More
                                </div> 
                            </CTAButton>
                        
                    </div>
                </div>


                <TimelineSection></TimelineSection>

            <LearningLanguageSection></LearningLanguageSection>

            </div>


            

        </div>

        {/* section 3 */}
        <div className='w-11/12 mx-auto max-w-maxContent flex flex-col items-center justify-between
        gap-8 bg-richblack-900 text-white'>
            <InstructorSection></InstructorSection>

            <h2 className='text-center text-4xl font-semibold mt-10'>Reviews from other learners</h2>

            {/* review slider here */}
            <ReviewSlider></ReviewSlider>
        </div>


        

        {/* footer */}
        <Footer></Footer>
    </div>
  )
}

export default Home